import type { Messages } from '../i18n/messages';

export const kafkaMessages: Messages = {
  // Entity tab titles — the sole rendered surface for these (no separate
  // header in the tab's own card), same pattern as
  // modules/catalog/ArgocdEntityContent.tsx: resolved at module scope via
  // `translate()` since EntityContentBlueprint params are non-component code.
  // "Kafka" is a brand/product name — identical en/fun.
  'kafka.serviceKafkaContent.title': { en: 'Kafka', fun: 'Kafka' },
  'kafka.topicKafkaContent.title': { en: 'Kafka', fun: 'Kafka' },

  'kafka.serviceCard.loadError': {
    en: 'Could not load Kafka data for this service.',
    fun: 'Kafka ghosted us for this service.',
  },
  'kafka.topicCard.emptyState': {
    en: 'No Kafka data for this topic.',
    fun: 'Zero Kafka gossip on this topic.',
  },
  'kafka.topicCard.loadError': {
    en: 'Could not load Kafka data for this topic.',
    fun: 'Kafka ghosted us for this topic.',
  },
};
